// extracted by mini-css-extract-plugin
export default {"circleBackground":"_1lAESSUgGIPAR3GHmEgK1t","circleProgress":"_1fFcL7eDEaKUvIMVgtALQU","circleText":"f3vKbE4uO3VT95ulPF6UE"};